const getters = {
  notiBar: state => state.notiBar,
  sticky: state => state.sticky,
  notiCenterStatus: state => state.notiBar.status,
  isLoadingNoti: state => state.notiBar.status.loadingNoti,
  isLoadingMoreNoti: state => state.notiBar.status.loadingMoreNoti,
  pinnedNoti: state => state.notiBar.pinnedNoti,
  noti: state => state.notiBar.noti,
  last_system_noti: state => state.notiBar.last_system_noti,
  noti_list_count: state => state.notiBar.noti_list_count,
  limit_pagination: state => state.notiBar.limit_pagination,
  noti_action: state => state.notiBar.action,
  noti_list_unread: state => state.notiBar.noti_list_unread
};

export default getters;
